module.exports = __webpack_public_path__ + "static/img/footer-logo.c9b0a4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/footer-logo.png
// module id = j+3Z
// module chunks = 18